export enum AppointmentFlowSteps {
  Scheduled = 'Scheduled',
  CheckedIn = 'Checked-In',
  InProgress = 'In-Progress',
  Admitted = 'Admitted',
  Finalized = 'Finalized',
  Paid = 'Paid',
  CompleteVisit = 'Complete Visit',
  NotShown = 'Not Shown',
}
